import { render, staticRenderFns } from "./addFileToExpence.vue?vue&type=template&id=6700bf98&scoped=true&"
import script from "./addFileToExpence.vue?vue&type=script&lang=js&"
export * from "./addFileToExpence.vue?vue&type=script&lang=js&"
import style0 from "./addFileToExpence.vue?vue&type=style&index=0&id=6700bf98&prod&lang=less&scoped=true&"
import style1 from "./addFileToExpence.vue?vue&type=style&index=1&id=6700bf98&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6700bf98",
  null
  
)

export default component.exports